import { Box, Flex, Tag, TagLabel, Tooltip } from '@chakra-ui/react';
import { ArticleCertificateBranch } from '@texas/api/endpoints/articlesApi';
import { CustomerComplianceDocument } from '@texas/api/endpoints/customersApi';
import { ComplianceDocumentDefinition } from '@texas/api/endpoints/metadata/complianceDocumentDefinitionsApi';
import { useTranslation } from 'react-i18next';
import { CertificateConfigurationSelect } from '../../CertificateConfigurationSelect';

interface Props {
  branch: ArticleCertificateBranch;
  definitions: ComplianceDocumentDefinition[];
  customerRequirements: CustomerComplianceDocument[];
  value: number[];
  onChange: (value: number[]) => void;
  isDisabled: boolean;
}

export function ArticleBranchCertificates({
  branch,
  definitions,
  customerRequirements,
  value,
  onChange,
  isDisabled,
}: Props) {
  const { t } = useTranslation();
  const missingRequirements = customerRequirements.filter(
    (requirement) =>
      !requirement.archived &&
      (!requirement.branches.length ||
        requirement.branches.some(({ id }) => id === branch.branchId)) &&
      !value.includes(requirement.complianceDocumentDefinitionId),
  );
  const missingCertificates = missingRequirements
    .map(({ name }) => name)
    .join(', ');

  return (
    <Flex align="center" gap={3}>
      {missingRequirements.length > 0 && (
        <Tooltip
          label={t('article.management.missingCustomerCertificates', {
            certificates: missingCertificates,
          })}
        >
          <Tag colorScheme="yellow" flexShrink={0} maxW="40%">
            <TagLabel
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {t('article.management.missingCertificates', {
                certificates: missingCertificates,
              })}
            </TagLabel>
          </Tag>
        </Tooltip>
      )}
      <Box flex={1} minW={0}>
        <CertificateConfigurationSelect
          branchName={branch.name}
          definitions={definitions}
          value={value}
          onChange={onChange}
          isDisabled={isDisabled}
        />
      </Box>
    </Flex>
  );
}
